/* No external scripts, tracking or checkout replacement. Shopify remains authoritative. */
(() => {
  function initPack(form) {
    if (form.dataset.awaReady) return;
    form.dataset.awaReady = 'true';
    const selectors = [...form.querySelectorAll('[data-pack-variant]')];
    const button = form.querySelector('[data-pack-submit]');
    const total = form.querySelector('[data-pack-total]');
    const error = form.querySelector('[data-pack-error]');
    if (!button || !total || !error || selectors.length !== 3) return;
    const format = new Intl.NumberFormat(document.documentElement.lang || 'fr', {style: 'currency', currency: form.dataset.currency || 'EUR'});
    const initialLabel = button.textContent;
    const update = () => {
      let amount = 0;
      let valid = form.dataset.busy !== 'true';
      selectors.forEach(select => {
        const option = select.selectedOptions[0];
        if (!option || option.disabled || !/^\d+$/.test(option.value)) valid = false;
        if (option) amount += Number(option.dataset.price || 0);
        const photo = form.closest('.awa-pack').querySelector(`[data-pack-image="${select.dataset.index}"]`);
        if (photo && option?.dataset.image) photo.src = option.dataset.image;
      });
      total.textContent = format.format(amount / 100);
      button.disabled = !valid;
    };
    selectors.forEach(select => select.addEventListener('change', update));
    update();
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (button.disabled || form.dataset.busy === 'true') return;
      form.dataset.busy = 'true';
      button.disabled = true;
      button.textContent = 'Ajout en cours…';
      error.hidden = true;
      try {
        const items = selectors.map(select => ({id: select.value, quantity: 1, properties: {Protocole: form.dataset.name}}));
        const addUrl = form.dataset.addUrl.endsWith('.js') ? form.dataset.addUrl : `${form.dataset.addUrl}.js`;
        const response = await fetch(addUrl, {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Impossible d’ajouter ces produits. Vérifie leur disponibilité.');
        window.location.assign(form.dataset.cartUrl);
      } catch (failure) {
        error.textContent = failure.message || 'Connexion interrompue. Vérifie ton panier avant de réessayer.';
        error.hidden = false;
        form.dataset.busy = 'false';
        button.textContent = initialLabel;
        update();
      }
    });
  }
  function init(root = document) { root.querySelectorAll('[data-awa-pack]').forEach(initPack); }
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
